import { Component, Input, OnInit } from '@angular/core';

import { IPlanSummaryResident, IPlanSummarySupervisor } from '../../../models/PlanSummary';
import { AppService } from '../../../services/app.service';
import { ParameterService } from '../../../services/parameter.service';
import { PlanSummaryEditMedicalPersonIdComponent } from '../edit-medical-person-id/plan-summary-edit-medical-person-id.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-plan-summary-base-info',
    templateUrl: './plan-summary-base-info.component.html',
    styleUrls: ['../plan-summary.component.scss']
})
export class PlanSummaryBaseInfoComponent implements OnInit {
    constructor(
        private app: AppService,
        private parameters: ParameterService,
        private modal: NgbModal
    ) { }

    @Input() resident: IPlanSummaryResident;
    @Input() supervisor: IPlanSummarySupervisor;

    workplaceAppUrl: string;
    clinicalBaseAppUrl: string;
    canEdit: boolean;

    get supervisorSet(): boolean {
        return this.supervisor != undefined;
    }

    ngOnInit() {
        if (this.app.currentUser) {
            const user = this.app.currentUser;
            const self = user.email == this.resident.Email;
            const canSet = user.rights.includes('APPLICATION.SET_STUDENT');

            this.canEdit = user.rights.includes('APPLICATION.LIST.PERSON_DATA') && (self || canSet);
        }

        this.app.addLoading(this.parameters.getValues()).subscribe(data => {
            this.workplaceAppUrl = data.find(t => t.Code == 'WorkplaceChangeAppUrl').Value;
            this.clinicalBaseAppUrl = data.find(t => t.Code == 'ClinicalBaseChangeAppUrl').Value;
        });
    }

    editMedicalPerson() {
        const ref = this.modal.open(PlanSummaryEditMedicalPersonIdComponent);
        ref.componentInstance.studentId = this.resident.StudentId;
        ref.componentInstance.medicalPersonId = this.resident.MedicalPersonId;
        ref.result.then((medicalPersonId: string) => {
            this.resident.MedicalPersonId = medicalPersonId;
        }, () => { });
    }
}
